module.exports = __webpack_public_path__ + "fonts/NoirPro-SemiBold.e928d2a2.woff2";